//NOTE(MTH): copied from node server
export enum LC_TABLE_IDS {
	systems = 2,
    tableRegister = 3,
    devicemaps = 5,
    feedplanTimes = 6,
    terminals = 7,
    feedcurves = 11,
    feeddays = 12, 
    stationConfig = 13,
}

export const TABLE_ID_TO_NAME: Record<LC_TABLE_IDS, string> = {
  [LC_TABLE_IDS.systems]: "System",
  [LC_TABLE_IDS.tableRegister]: "Register",
  [LC_TABLE_IDS.devicemaps]: "Device Map",
  [LC_TABLE_IDS.feedplanTimes]: "Feed Plan Time",
  [LC_TABLE_IDS.terminals]: "Terminal",
  [LC_TABLE_IDS.feedcurves]: "Feed Curve",
  [LC_TABLE_IDS.feeddays]: "Feed Day",
  [LC_TABLE_IDS.stationConfig]: "Station Config",
};